import { createFileRoute } from '@tanstack/react-router';
import { isPermissionFull } from '@/features/login/util/permission';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/contas-pagar')({
    beforeLoad: () =>
        validateRoute({
            fintech: true,
            validatePermission: ({ upp_financeiro_conta_pagar }) =>
                isPermissionFull(upp_financeiro_conta_pagar),
        }),
});
